module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_22.638a211f.png";